// Left to Free Shipping Function
(function() {
  window.addEventListener('load', () => {
    setTimeout(() => {
      const cartValueAnnounce = document.querySelector('#cart_value_announce');
      const buyMore = document.querySelector('#buy_more_save');
      if (!cartValueAnnounce) return;

      if (window.AfterShipPersonalization?.Cart) { 
        const cart = window.AfterShipPersonalization?.Cart;
        total_price = cart?.data.total_price;
        // console.log('cart:', cart, 'total_price:', total_price);
        if (total_price > 0 && (total_price / 100) < 100) {
          cartValueAnnounce.classList.remove('hidden');
        } else {
          cartValueAnnounce.classList.add('hidden');
          buyMore.classList.remove('hidden');
        }
      }
    }, 350);
  })

  document.addEventListener('apz:smartCart:update', (event) => {
    // console.log('aftership cart:', event);
    const cartValueAnnounce = document.querySelector('#cart_value_announce');
    const buyMore = document.querySelector('#buy_more_save');
    if (!cartValueAnnounce) return;

    if (window.AfterShipPersonalization?.Cart) { 
      const cart = window.AfterShipPersonalization?.Cart;
      total_price = cart?.data.total_price
      // console.log('cart:', cart, 'total_price:', total_price);
      if (total_price > 0 && (total_price / 100) < 100) {
        let html = `${100 - Math.floor(total_price / 100)}`;
        cartValueAnnounce.querySelector('.cart-remaining').innerHTML = html;
        cartValueAnnounce.classList.remove('hidden');
        buyMore.classList.add('hidden');
      } else {
        cartValueAnnounce.classList.add('hidden');
        buyMore.classList.remove('hidden');
      }
    }
  })
})();